import React from "react";
import { BarChart, Check, Crypto, Percentage, Trade } from "../assets/img";

const HowItWorks = () => {
    return (
        <>
            <div className="hidden lg:block">
                <div className="hidden relative lg:grid h-[600px]">
                    <div className="absolute h-full top-0 left-0 md:grid grid-cols-1 lg:grid-cols-2 w-full">
                        <div className="bg-primary h-full"></div>
                        <div className="bg-white h-full"></div>
                    </div>
                    <div className="absolute h-full lg:h-auto w-10/12 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 grid grid-cols-1 lg:grid-cols-2 font-poppins">
                        <div className="bg-primary flex p-6 lg:p-10 md:p-20 order-1">
                            <div className="container">
                                <div className="flex flex-col justify-center h-full">
                                    <h1 className="text-xl md:text-6xl lg:text-8xl font-bold text-center lg:text-right uppercase text-white">
                                        <span>How</span>
                                        <br className="hidden md:block" />
                                        <span className="ml-2 md:ml-0">It</span>
                                        <br className="hidden md:block" />
                                        <span className="ml-2 md:ml-0">
                                            Works
                                        </span>
                                    </h1>
                                </div>
                            </div>
                        </div>
                        <div className="bg-white p-3 mt-4 lg:mt-0 md:py-20 pl-12 px-0 order-2">
                            <div className="flex items-center">
                                <div className="w-10 h-10 md:w-16 flex-shrink-0 md:h-16 bg-primary flex items-center justify-center text-white rounded-full">
                                    <img src={Check} alt="" className="w-1/3" />
                                </div>
                                <p className="pl-2 md:pl-4 text-xs md:text-base">
                                    We perform an Independent pre IPO due
                                    diligence process of a sports team.
                                </p>
                            </div>
                            <div className="flex items-center mt-6 md:mt-12">
                                <div className="w-10 h-10 md:w-16 flex-shrink-0 md:h-16 bg-primary flex items-center justify-center text-white rounded-full">
                                    <img src={Percentage} alt="" className="w-1/3" />
                                </div>
                                <p className="pl-2 md:pl-4 text-xs md:text-base">
                                    We calculate the intrinsic value of an
                                    athlete and the team ownership
                                    representation.
                                </p>
                            </div>
                            <div className="flex items-center mt-6 md:mt-12">
                                <div className="w-10 h-10 md:w-16 flex-shrink-0 md:h-16 bg-primary flex items-center justify-center text-white rounded-full">
                                    <img src={Crypto} alt="" className="h-1/2" />
                                </div>
                                <p className="pl-2 md:pl-4 text-xs md:text-base">
                                    After regulatory qualification, we tokenize
                                    the ownership and issue shares.
                                </p>
                            </div>
                            <div className="flex items-center mt-6 md:mt-12">
                                <div className="w-10 h-10 md:w-16 flex-shrink-0 md:h-16 bg-primary flex items-center justify-center text-white rounded-full">
                                    <img src={Trade} alt="" className="h-1/2" />
                                </div>
                                <p className="pl-2 md:pl-4 text-xs md:text-base">
                                    Via our secure portal buy, sell and trade
                                    shares as you wish 24/7.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="hidden relative lg:grid h-[700px]">
                    <div className="absolute h-full top-0 left-0 md:grid grid-cols-1 lg:grid-cols-2 w-full">
                        <div className="bg-white h-full"></div>
                        <div className="bg-secondary h-full"></div>
                    </div>
                    <div className="absolute h-full lg:h-auto w-10/12 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 grid grid-cols-1 lg:grid-cols-2 font-poppins">
                        <div className=" lg:order-3">
                            <img src={BarChart} alt="" />
                        </div>
                        <div className="bg-secondary flex items-center  py-6 px-0  lg:p-10 md:p-20 order-3 lg:order-4">
                            <h1 className=" mx-auto text-xl md:text-5xl xl:text-7xl tracking-wide font-bold uppercase md:!leading-[98px] text-white text-center md:text-left">
                                <span className="">Price</span>
                                <br className="hidden md:block" />
                                <span className="ml-2 md:ml-0">
                                    appreciation
                                </span>
                                <br className="hidden md:block" />
                                <span className="ml-2 md:ml-0">vs</span>
                                <br className="hidden md:block" />
                                <span className="ml-2 md:ml-0">
                                    other asset classes
                                </span>
                                <br className="hidden md:block" />
                                <span className="ml-2 md:ml-0">
                                    1995 to 2022
                                </span>
                                <br className="hidden md:block" />
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid lg:hidden grid-cols-1 lg:grid-cols-2 font-poppins">
                <div className="bg-primary p-10 md:p-20 order-1">
                    <div className="container">
                        <div className="flex flex-col justify-center h-full">
                            <h1 className="text-xl md:text-6xl lg:text-8xl font-bold text-center lg:text-right uppercase text-white">
                                <span>How</span>
                                <br className="hidden md:block" />
                                <span className="ml-2 md:ml-0">It</span>
                                <br className="hidden md:block" />
                                <span className="ml-2 md:ml-0">Works</span>
                            </h1>
                        </div>
                    </div>
                </div>
                <div className="px-8 py-5 my-4 lg:mt-0 md:p-20 md:px-8 order-2 flex flex-col gap-8">
                    <div className="flex items-center">
                        <div className="w-10 h-10 md:w-16 flex-shrink-0 md:h-16 bg-primary flex items-center justify-center text-white rounded-full">
                            <img src={Check} alt="" className="w-1/3" />
                        </div>
                        <p className="pl-2 md:pl-4 text-base md:text-lg">
                            We perform an Independent pre IPO due diligence
                            process of a sports team.
                        </p>
                    </div>
                    <div className="flex items-center">
                        <div className="w-10 h-10 md:w-16 flex-shrink-0 md:h-16 bg-primary flex items-center justify-center text-white rounded-full">
                            <img src={Percentage} alt="" className="w-1/3" />
                        </div>
                        <p className="pl-2 md:pl-4 text-base md:text-lg">
                            We calculate the intrinsic value of an athlete and
                            the team ownership representation.
                        </p>
                    </div>
                    <div className="flex items-center">
                        <div className="w-10 h-10 md:w-16 flex-shrink-0 md:h-16 bg-primary flex items-center justify-center text-white rounded-full">
                            <img src={Crypto} alt="" className="h-1/2" />
                        </div>
                        <p className="pl-2 md:pl-4 text-base md:text-lg">
                            After regulatory qualification, we tokenize the
                            ownership and issue shares.
                        </p>
                    </div>
                    <div className="flex items-center">
                        <div className="w-10 h-10 md:w-16 flex-shrink-0 md:h-16 bg-primary flex items-center justify-center text-white rounded-full">
                            <img src={Trade} alt="" className="h-1/2" />
                        </div>
                        <p className="pl-2 md:pl-4 text-base md:text-lg">
                            Via our secure portal buy, sell and trade shares as
                            you wish 24/7.
                        </p>
                    </div>
                </div>
                <div className="md:p-20 order-4 lg:order-3">
                    <img src={BarChart} alt="" />
                </div>
                <div className="bg-secondary flex items-center py-10 px-0 md:p-20 order-3 lg:order-4">
                    <h1 className="mx-auto md:mx-0 text-xl md:text-4xl xl:text-7xl tracking-wide font-bold uppercase md:!leading-[98px] text-white text-center md:text-left">
                        <span className="">Price</span>
                        <br className="hidden md:block" />
                        <span className="ml-2 md:ml-0">appreciation</span>
                        <br className="hidden md:block" />
                        <span className="ml-2 md:ml-0">vs</span>
                        <br className="hidden md:block" />
                        <span className="ml-2 md:ml-0">
                            other asset classes
                        </span>
                        <br className="hidden md:block" />
                        <span className="ml-2 md:ml-0">1995 to 2022</span>
                        <br className="hidden md:block" />
                    </h1>
                </div>
            </div>
        </>
    );
};

export default HowItWorks;
